(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  /* プログレスバー: 完了スライドの管理 */
  const section = document.querySelector('.slideshow-section');
  if (section) {
    const component = section.querySelector('slideshow-component');
    if (component) {
      const updateBars = () => {
        const dots = component.querySelectorAll('.slideshow-controls__dots button');
        dots.forEach((dot, i) => {
          const isActive = dot.getAttribute('aria-selected') === 'true';
          if (isActive) {
            dot.classList.remove('slide-complete');
            /* アニメーション再起動: reflow強制 */
            dot.style.animation = 'none';
            dot.offsetHeight;
            dot.style.animation = '';
          } else {
            /* アクティブより前 = 完了、後 = 未完了 */
            const activeIndex = [...dots].findIndex(d => d.getAttribute('aria-selected') === 'true');
            dot.classList.toggle('slide-complete', i < activeIndex);
          }
        });
      };

      /* MutationObserverでaria-selected変化を監視 */
      const observer = new MutationObserver(updateBars);
      const dots = component.querySelectorAll('.slideshow-controls__dots button');
      dots.forEach(dot => {
        observer.observe(dot, { attributes: true, attributeFilter: ['aria-selected'] });
      });

      /* 初期状態を設定 */
      updateBars();
    }
  }

  } catch(e) { console.error(e); }
})();
})();
